import React from "react";
import { colors } from "src/config/colors";
import Box from "@mui/material/Box";
import Link from "src/components/common/Links/Link";
import { List, ListItem, Typography } from "@mui/material";
import {
  bandsAbcItemSchema,
  brandsAbcSchema,
} from "src/models/brandsAbc/getBrandsAbc";
import { scrollToId } from "src/utils/helpers/scrollTo/scrollToId";
import { createUrl } from "src/utils/helpers/url/createUrl";
import { useQuery } from "src/utils/hooks/common/useQuery";
import paths from "src/router/paths";

interface AlphabetSearchProps {
  brandsAbcData: brandsAbcSchema;
}

const AlphabetSearch: React.FC<AlphabetSearchProps> = ({ brandsAbcData }) => {
  const { city } = useQuery(["city"]);

  const letterList = Object.keys(brandsAbcData);

  return (
    <Box mt={3}>
      <Typography
        fontSize={22}
        lineHeight="30px"
        color={colors.blue}
        component="h2"
      >
        Поиск по алфавиту
      </Typography>
      <Box
        component="ul"
        display="flex"
        flexWrap="wrap"
        padding={0}
        alignItems="center"
        sx={{ listStyleType: "none" }}
        marginBottom={2}
      >
        {letterList.map((abcValue) => (
          <Typography
            component="li"
            key={abcValue}
            sx={{
              marginRight: 3,
              marginBottom: 5,
              fontSize: "20px",
            }}
          >
            <Link
              prefetch={false}
              replace
              sx={{
                textDecoration: "none",
                ":hover": {
                  color: "#ccc",
                },
              }}
              href={`#${abcValue}`}
              onClick={() => scrollToId(abcValue)}
            >
              {abcValue.toUpperCase()}
            </Link>
          </Typography>
        ))}
        <List sx={{ width: "100%" }} disablePadding>
          {brandsAbcData &&
            letterList.map((value, index) => (
              <ListItem disablePadding key={index}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  <Typography
                    variant="h2"
                    component="h3"
                    fontWeight={550}
                    sx={{ textTransform: "uppercase", mr: 2, mb: 2 }}
                    id={value}
                  >
                    {value}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      mb: 4,
                    }}
                  >
                    {brandsAbcData[value].map((item: bandsAbcItemSchema) => (
                      <Link
                        prefetch={false}
                        sx={{
                          color: colors.shadowBlue,
                          textDecoration: "none",
                          flexWrap: "nowrap",
                          fontSize: 15,
                          mr: 4,
                          mb: 1,
                          ":hover": {
                            color: colors.darkBlue,
                          },
                        }}
                        key={item.id}
                        href={createUrl([
                          city,
                          paths.CATEGORY,
                          item.brand_slug,
                        ])}
                      >
                        {item.brand_name}
                      </Link>
                    ))}
                  </Box>
                </Box>
              </ListItem>
            ))}
        </List>
      </Box>
    </Box>
  );
};
export default AlphabetSearch;
